export enum TapPriority {
    High = 1,
    Medium = 2,
    Low = 3,
}

export type ITapPriority = {
    code: TapPriority,
    name: string,
    icon: {
        name: string,
        color?: string,
        backgroundColor?: string,
    },
}

export const TapPriorityList: ITapPriority[] = [
    {
        code: TapPriority.High,
        name: 'Высокий',
        icon: {
            name: 'North',
            color: '#dd2c00',
            backgroundColor: '#e57373',
        },

    },
    {
        code: TapPriority.Medium,
        name: 'Средний',
        icon: {
            name: 'HorizontalRule',
            backgroundColor: '#90a4ae',
        },

    },
    {
        code: TapPriority.Low,
        name: 'Низкий',
        icon: {
            name: 'South',
            color: '#2e7d32',
            backgroundColor: '#81c784',
        },

    },
];